var _Array$isArray = require("core-js-pure/features/array/is-array.js");
function _arrayWithHoles(arr) {
  if (_Array$isArray(arr)) return arr;
}
module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/helpers/arrayWithHoles.js
// module id = /SsA
// module chunks = 19